import Service from './Service'

/**
 * Password API service.
 *
 * @author Alejandro Sanchez <asanchez@claruscare.com>
 */
export default class Password extends Service {
	static get inject() {
		return ['App/Http/AuthRequest']
	}
	/**
	 * Request a forgot or set password email be sent.
	 *
	 * @param {String} email
	 * @param {String} [action]
	 * @return {Promise}
	 */
	forgot(email, action) {
		const url = action
			? `v1/reset-password/request?action=${encodeURIComponent(action)}`
			: 'v1/reset-password/request'

		return this.request.post(url, { email })
	}

	/**
	 * Confirm a set or reset link is still stored.
	 *
	 * Send the URL claims when the link has them, otherwise the email.
	 *
	 * @param {String} token
	 * @param {Object} payload
	 * @param {String} [payload.email]
	 * @param {String} [payload.claims]
	 * @return {Promise}
	 */
	validate(token, { email, claims } = {}) {
		const body = claims ? { claims } : { email }

		return this.request.post(`v1/reset-password/${token}/validate`, body)
	}

	/**
	 * Reset a user's password via a password reset token.
	 *
	 * @param {String} code
	 * @param {String} email
	 * @param {String} password
	 * @param {String} password_confirmation
	 * @return {Promise}
	 */
	update(token, code, email, password, password_confirmation) {
		const url = code ? 'v1/reset-password' : `v1/reset-password/${token}`
		const body = {
			...(code && { token: code }),
			email,
			password,
			password_confirmation,
		}
		return this.request.http.post(url, body)
	}
}
